<template>
  <div />
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      sateliteIsReady: false
    };
  },

  mounted() {
    this.isDTMReady();
  },
  computed: {
    ...mapState({
      dtm: state => state.dtm
    })
  },
  methods: {
    isDTMReady() {
      if (!this.dtm) {
        setInterval(() => {
          if (window._satellite && !this.dtm) {
            _satellite.pageBottom();
            this.$store.commit("SET_DTM", true);
            
          }
        }, 500);
      }
    }
  }
};
</script>

<style>
</style>
